import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ButtonBase = styled.button`
    padding: 0.5em 2em;
    border-radius: 2em; 
    font-size: 1.125rem;
    transition: 0.5s opacity;
`;

const ButtonP = styled(ButtonBase)`
    background-color: ${({ theme }) => theme.color.highlightColor};
    color: white;
    &[disabled] {
        background-color: ${({ theme }) =>
        theme.color.highlightColorVariants.w25};
    }
`;

const Secondary = styled(ButtonBase)`
    background-color: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.grey1};
`;

function getVariant(variant) {
    switch (variant) {
        case 'secondary':
            return Secondary;

        default:
            return ButtonP;
    }
}

function Button(props) {
    const Comp = getVariant(props.variant);

    return <Comp {...props} />;
}

Button.propTypes = {
    variant: PropTypes.string,
};

export default Button;
